import z from 'zod'

import {
  accountSchema,
  baseTransactionSchema,
  chainIdSchema,
} from '~/components/smart-accounts/schemas'

export const positionClaimSchema = baseTransactionSchema.and(
  z.object({
    account: accountSchema,
    chainId: chainIdSchema,
  }),
)

export type PositionClaimFormValues = z.input<typeof positionClaimSchema>
